 <script>   
     export let items = []
     export let selected = null
     export let labelKey = null
     export let valueKey = 'id'
    //  export let isList = false;
    
 </script>
 
 <select  bind:value={selected}  {...$$restProps}>
    <slot name="default_option">
        <option  value={null}> --- </option>
    </slot>
    {#if items}
        {#each items as item }            
            <slot {item}>
                {#if labelKey }                    
                    <option selected={selected?item[valueKey] == selected[valueKey]:false} value={item}>{item[labelKey]}</option>                    
                {:else}                    
                    <option selected={item == selected } value={item}>{item}</option>
                {/if}                
            </slot>
        {/each}
    {/if}
</select>